import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { useMeetingSelector, useMultiMeetingAPI } from "../../hooks/meeting";
import { PageMasterMode, usePageContext } from "../navigation/PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";
import { BaseTopBar } from "./BaseTopBar";
import { useCallback, useMemo } from "react";
import { isExpert } from "../../helpers/roles";
import { useAppStoreDispatch } from "../../contexts/appStore/context";

export interface MasterTopBarProps {
  onSettings?: () => void;
  settingsBtnRef?: React.Ref<HTMLDivElement>;
}

export const MasterTopBar: React.FC<MasterTopBarProps> = ({
  onSettings,
  settingsBtnRef,
}) => {
  const dispatch = useAppStoreDispatch();
  const user = useAppStoreSelector(state => state.user);

  const pageContext = usePageContext<SessionMode.MASTER>();
  const pageContextRef = useRefAutoUpdate(pageContext);

  const { focusedMeetingAPI } = useMultiMeetingAPI(
    pageContextRef.current?.params?.id,
    true,
    true,
  );

  const [meetingId] = useMeetingSelector(focusedMeetingAPI, state => state.meeting?.id);
  const [meetingName] = useMeetingSelector(focusedMeetingAPI, state => state.meeting?.name);
  const [meetingStartedAt] = useMeetingSelector(focusedMeetingAPI, state => state.meeting?.startedAt);
  const [sessions] = useMeetingSelector(focusedMeetingAPI, state => state.meeting?.sessions);

  const watchingNumber = useMemo(() => {
    return sessions?.filter(s => !isExpert(s)).length;
  }, [sessions]);

  const onBack = useCallback(() => {
    pageContextRef.current?.goTo(PageMasterMode.LIST);
    if (meetingId) {
      dispatch("setLastLeftMeetingId", meetingId);
    }
  }, []);
  const showBack = useMemo(() => ![PageMasterMode.LIST, PageMasterMode.LOGIN].includes(pageContextRef.current?.page!!), []);

  return (
    <BaseTopBar
      user={user}
      meetingName={meetingName}
      meetingStartedAt={meetingStartedAt}
      showDate={!meetingName} // show date if no meeting
      showLogo={true}
      onSettings={onSettings}
      onBack={showBack ? onBack : undefined}
      watchingNumber={watchingNumber}
      settingsBtnRef={settingsBtnRef}
    />
  );
}